module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firebaseFeedback) ? _c('div', {
    staticClass: "login-root"
  }, [(!_vm.user) ? _c('button', {
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.logIn
    }
  }, [_vm._v("Sign in with GitHub")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.openDropdown
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.user.photoURL,
      "alt": _vm.user.displayName
    }
  }), _vm._v(" "), _c('svg', {
    attrs: {
      "fill": "#66BB6A",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 10l5 5 5-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.dropdownOpen && _vm.user) ? _c('div', {
    staticClass: "menu-content"
  }, [_c('div', {
    staticClass: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-header"
  }, [_vm._v("\n        Signed in as "), _c('strong', {
    staticClass: "dropdown-name"
  }, [_vm._v(_vm._s(_vm.user.displayName || _vm.user.email || 'Anonymous'))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), (_vm.routePath === '/') ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/ranking"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDropdown($event)
      }
    }
  }, [_vm._v("High scores")]) : _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDropdown($event)
      }
    }
  }, [_vm._v("Play the game")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("Sign out")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://github.com/samiheikki/javascript-guessing-game"
    }
  }, [_vm._v("Source code")])], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f376786"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginView.vue
// module id = 147
// module chunks = 1